
class ProgramImg
{
  // ---------------------------------------------------------------------------------------------------------
	// --	ProgramImg
	// ---------------------------------------------------------------------------------------------------------

  constructor(target)
  {
    //ターゲット保持
    this.target = target

    //画像
    this.img = this.target.find('>img')

    //画像の大きさ
    this.xRange = this.img.width() - this.target.width()
    this.yRange = this.img.height() - this.target.height()
    this.xDir = this.target.data().parallaxX
    this.yDir = this.target.data().parallaxY
  }

  update(scrollY)
  {
    //判定用スクロール範囲
    const scrollRange = $(window).innerHeight() + this.target.height()

    //パララックスの割合
    const currentTop = -(this.target.offset().top - scrollY - $(window).innerHeight())
    let rate = currentTop/scrollRange
    if(rate < 0) rate = 0
    if(rate > 1) rate = 1

    //位置更新
    gsap.set(this.img, {
      x:this.xRange * rate * this.xDir,
      y:this.yRange * rate * this.yDir
    })
  }
 
  // ---------------------------------------------------------------------------------------------------------
}

export default ProgramImg
